/* eslint-disable no-undef */
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

const domConfig = require('./dom_config'); // contains 'simple' actions that can be tracked and reported to tracking hub

module.exports = class PageTracking {
  constructor() {
    this.recordedFirstPage = false;
  }

  pageReady() {
    if (this.recordedFirstPage) {
      return null;
    }

    if (!Groupon.Performance) {
      return null;
    }

    Groupon.Performance.pageReady();

    this._trackExperimentPerformance();

    this.recordedFirstPage = true;
    return this.recordedFirstPage;
  }

  _trackExperimentPerformance() {
    const config = domConfig.get() || {};

    if (config.appliedFinchSettings && config.appliedFinchSettings.length) {
      return null;
    }

    if (!BOOMR.getVar) {
      window.addEventListener('onBoomerangLoaded', () => {
        return this._trackExperimentPerformance();
      });
      return null;
    }

    const tResp = BOOMR.getVar('t_resp');
    const tPage = BOOMR.getVar('t_page');
    const tDone = BOOMR.getVar('t_done');
    const experimentVariants = [];
    const appliedFinchSettings = config.appliedFinchSettings || [];
    const variants = []
      .concat(experimentVariants, appliedFinchSettings)
      .join(',');
    return OptimizeSuite.TrackingHub.add('pull_experiment_performance', {
      t_resp: tResp,
      t_page: tPage,
      t_done: tDone,
      variants,
    });
  }
};
